import React from "react";

function val(row, key) {
  return String(row?.[key] || "").trim();
}

export default function AdminVbs({ loading, error, rows = [], fetchVbs }) {
  return (
    <div style={{ marginTop: 12 }}>
      <div className="admin-actions" style={{ marginTop: 14 }}>
        <div className="view-toggle">
          <h2 style={{ margin: 0 }}>VBS Registrations</h2>
        </div>
        <div className="right-controls">
          <button className="btn" onClick={fetchVbs}>Refresh</button>
        </div>
      </div>

      {loading ? <div className="muted">Loading…</div> : null}
      {error ? <div className="error">{error}</div> : null}

      {!loading && !error ? (
        <div style={{ overflowX: "auto", marginTop: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #eee", textAlign: "left" }}>
                <th style={{ padding: "8px 12px" }}>Child first name</th>
                <th style={{ padding: "8px 12px" }}>Child last name</th>
                <th style={{ padding: "8px 12px" }}>DOB</th>
                <th style={{ padding: "8px 12px" }}>Allergies?</th>
                <th style={{ padding: "8px 12px" }}>Allergy details</th>
                <th style={{ padding: "8px 12px" }}>Parent/guardian</th>
                <th style={{ padding: "8px 12px" }}>Parent email</th>
                <th style={{ padding: "8px 12px" }}>Parent phone</th>
                <th style={{ padding: "8px 12px" }}>Parent bringing child?</th>
                <th style={{ padding: "8px 12px" }}>Alternate pickup/dropoff</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => {
                const parentName = `${val(row, "parentFirstName")} ${val(row, "parentLastName")}`.trim();
                const alternateName = `${val(row, "pickupFirstName")} ${val(row, "pickupLastName")}`.trim();
                const alternateBlock = [alternateName, val(row, "pickupPhone")].filter(Boolean).join(" - ");

                return (
                  <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                    <td style={{ padding: "10px 12px" }}>{val(row, "childFirstName")}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "childLastName")}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "childDob")}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "hasAllergies")}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "allergyDetails")}</td>
                    <td style={{ padding: "10px 12px" }}>{parentName}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "parentEmail")}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "parentPhone")}</td>
                    <td style={{ padding: "10px 12px" }}>{val(row, "parentBringingChild")}</td>
                    <td style={{ padding: "10px 12px" }}>{alternateBlock}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {!rows.length ? <div className="muted" style={{ marginTop: 10 }}>No VBS registrations yet.</div> : null}
        </div>
      ) : null}
    </div>
  );
}